import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Category from '@mui/icons-material/Category';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Stepper from './Editsupplystepper';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setloading] = React.useState(false);
  // Snackbar state
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // Ref to access the Stepper component's methods (if it supports resetting)
  const stepperRef = React.useRef(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    props.setfalser();
    setOpen(false);
  };

  // Function to handle Snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  // Function to clear form fields
  const clearForm = () => {
    const form = document.getElementById('process-form');
    if (form) {
      form.reset();
    }
    // If the Stepper component has a reset method, call it
    if (stepperRef.current && typeof stepperRef.current.reset === 'function') {
      stepperRef.current.reset();
    }
    // Add any additional state resets here if the Stepper manages state
  };

  const Food = [
    { value: 'Cereals' },
    { value: 'Industrial crops' },
    { value: 'Legumes' },
    { value: 'Fruits' },
    { value: 'Vegetables' },
    { value: 'Starchy' },
    { value: 'tuber' },
    { value: 'root crops' },
  ];

  const addproduct = () => {
    setloading(true);
    const doer = async () => {
      try {
        // Adjust the request body based on your API requirements
        // Example placeholder fields (update these to match your Stepper's form fields)
        const response = await axios.post(
          'https://server.agrotraciserp.com/api/discount/', // Fixed URL (removed double slash)
          {
            // Example fields; replace with actual form data from Stepper
            processName: document.getElementById('processName')?.value || '',
            category: document.getElementById('category')?.value || '',
            description: document.getElementById('description')?.value || '',
            // Add other fields as needed
          }
        );

        if (response.status === 200) {
          setloading(false);
          setSnackbar({
            open: true,
            message: 'Process added successfully!',
            severity: 'success',
          });
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbar({
            open: true,
            message: 'Failed to add process',
            severity: 'error',
          });
        }
      } catch (err) {
        setloading(false);
        setSnackbar({
          open: true,
          message: 'Error adding process',
          severity: 'error',
        });
      }
    };
    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>
        Add New Process
      </Button>

      <Dialog
        fullWidth={true}
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new Process
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            id="process-form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <Stepper ref={stepperRef} />
          </Box>
          <br />
        </DialogContent>
        <DialogActions>
          {loading ? (
            <Button variant="outlined" startIcon={<Progress />} disabled>
              Loading...
            </Button>
          ) : (
            <Button variant="outlined" startIcon={<Category />} onClick={addproduct}>
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}